export default __webpack_public_path__ + "static/media/linkIconWhite.c5f383d3.svg";